import { ElMessageBox } from 'element-plus'
import { getCurrentInstance } from 'vue'
// 删除弹框
export default function myconfirm(text: string, t: any) {
  if (!t) {
    throw new Error('i18n instance is required')
  }
  return new Promise((resolve, reject) => {
    ElMessageBox.confirm(text, t('message.systemPrompt'), {
      confirmButtonText: t('buttons.confirm'),
      cancelButtonText: t('buttons.cancel'),
      type: 'warning'
    }).then(() => {
      // 用户点击了确定按钮
      resolve(true)
    }).catch(() => {
      // 用户点击了取消按钮或发生了其他错误
      resolve(false) // 通常我们不需要reject，而是resolve为false表示用户取消了操
    })
  })
}
